import { fetchClient } from "@/api/api";
import type {
	listPeriodicJobsOutput,
	triggerPeriodicJobInput,
} from "@/api/custom_types";
import useApiError from "@/hooks/useApiError";
import type { ApiError } from "@/utils/fetching";
import type { CustomMutationHook, CustomQueryHook } from "@/utils/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ADMIN_PERIODIC_JOBS_SERVICE_KEYS } from "./keys";

export const useListPeriodicJobs: CustomQueryHook<
	listPeriodicJobsOutput,
	undefined,
	listPeriodicJobsOutput
> = (options) => {
	return useQuery({
		...options,
		queryKey: ADMIN_PERIODIC_JOBS_SERVICE_KEYS.useListPeriodicJobs(),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/fc/admin/periodic-jobs/",
				{ throwOnError: true },
			);
			if (error) throw error;
			return data;
		},
	});
};

export const useTriggerPeriodicJob: CustomMutationHook<
	triggerPeriodicJobInput,
	void
> = (mutationOptions) => {
	const { toastApiError } = useApiError();

	return useMutation<void, ApiError, triggerPeriodicJobInput>({
		...mutationOptions,
		mutationKey: ADMIN_PERIODIC_JOBS_SERVICE_KEYS.useTriggerPeriodicJob(),
		mutationFn: async (body) => {
			const { error } = await fetchClient.POST("/v1/fc/admin/periodic-jobs", {
				body,
				throwOnError: true,
			});
			if (error) throw error;
		},
		onError: (error, variables, onMutateResult, mutationContext) => {
			toastApiError(error);
			mutationOptions?.onError?.(
				error,
				variables,
				onMutateResult,
				mutationContext,
			);
		},
	});
};
